module.exports = require("react-native/Libraries/Core/Devtools/getDevServer");
